import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PreferredCityDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-cities-display',
  imports: [MatIconModule],
  templateUrl: './agent-cities-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentCitiesDisplayComponent {
  readonly preferredCities = input<PreferredCityDto[] | undefined>(undefined);
}
